<template>
  <v-data-table :headers="headers" :items="allIrpfReports" :items-per-page="10000" class="elevation-1" hide-default-footer
    :sortable='false' v-if="allIrpfReports.length">
    <template v-slot:body="{ items }">
      <tbody>
        <tr v-for="item in items" :key="item.proposta">
          <td class="text-left">{{ item.ano }}</td>
          <td class="text-left">{{ item.nome }}</td>
          <td class="text-left">{{ item.operadora }}</td>
          <td class="text-left">
            <v-btn @click="downloadIR(item)" text icon small color="green"><v-icon small>fa fa-download</v-icon></v-btn>
          </td>
        </tr>
      </tbody>
    </template>
  </v-data-table>
  <p v-else>{{ irpfMessage }}.</p>
</template>
<script>
export default {
  methods: {
    downloadIR(data) {
      // {
      // "cpf": "99999999999",
      // "kw": "xxxxxxxxxxxxxxx",
      // "codigoir": 88888888
      // }
      let obj = {
        url: "/getInform",
        query: { cpf: data.cpf, codigoir: data.codigo, kw: localStorage.corporeToken },
        method: "post",
      };
      // console.log("sssss");
      this.$store.dispatch("request/doRequest", obj).then((resp) => {
        console.log('resp');
        if (!resp) {
          return;
        }
        window.open(resp.data.link);
      });
    }
  },
  data() {
    return {
      headers: [
        { text: "Ano Exercício", value: "ano" },
        { text: "Nome", value: "nome" },
        { text: "Operadora ", value: "operadora" },
        { text: "Download", value: "" }
      ],
    }
  },
  props: {
    irpfMessage: String,
    allIrpfReports: Array
  }
}
</script>
